import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';

import 'normalize.css';

import configureStore from './store/store';
import Root from './components/root';

const HL_GOOGLE_ANALYTICS_ID = process.env.HL_GOOGLE_ANALYTICS_ID || 'UA-26124207-25';

document.addEventListener('DOMContentLoaded', () => {
    ReactGA.initialize(HL_GOOGLE_ANALYTICS_ID);
    
    const store = configureStore();

    const root = document.getElementById('root');

    ReactDOM.render(<Root store={store} />, root);
});
